import React from 'react';
import {Card, CardBody, CardHeader, ListGroup, ListGroupItem,} from 'reactstrap';
import ElementCardActions from './ElementCardActions';

import CheckoffResponse from './../reports/dynamic-form/CheckoffResponse';
import CommentResponse from './../reports/dynamic-form/CommentResponse';
import DatetimeResponse from './../reports/dynamic-form/DatetimeResponse';
import RatingResponse from './../reports/dynamic-form/RatingResponse';
import RatingMultiResponse from "../reports/dynamic-form/RatingMultiResponse";
import {connect} from "react-redux";
import RatingSimple from "../reports/dynamic-form/RatingSimple";
import RemedialTrainingResponse from "../reports/dynamic-form/RemedialTrainingResponse";
import CallTrackingResponse from "../reports/dynamic-form/CallTrackingResponse";
import DailyPatrolLogResponse from "../reports/dynamic-form/DailyPatrolLogResponse";
import LogFieldResponse from "../reports/dynamic-form/LogFieldResponse";
import QuestionFieldResponse from "../reports/dynamic-form/QuestionFieldResponse";
import PtoRatingMultiResponse from "../reports/dynamic-form/PtoRatingMultiResponse";
import TimeTrackingField from "../reports/dynamic-form/TimeTrackingField";
import PbleField from "../reports/dynamic-form/PbleField";
import EvaluationRatingResponse from "../reports/dynamic-form/EvaluationRatingResponse";


const DynamicFieldPreview = (props) => {

  switch (props.element.schema) {
    case 'checkoff':
      return (
        <CheckoffResponse
          onValueChange={(key, valueObject) => {
          }}
          prompt={props.element.prompt}
          checkoffPrompt={props.element.checkoffPrompt}
          value={{
            isChecked: true
          }}

        />
      );
    case 'comment':
      return (
        <CommentResponse
          onValueChange={(key, valueObject) => {
          }}
          prompt={props.element.prompt}
          requireResponse={props.element.requireResponse}
          value={{
            comment: 'The comment example'
          }}
        />

      );
    case 'datetime':
      return (
        <DatetimeResponse
          onValueChange={(key, valueObject) => {
          }}
          prompt={props.element.prompt}
          value={{
            datetime: new Date()
          }}
        />
      );
    case 'rating':
      return (
        <RatingResponse
          onValueChange={(key, valueObject) => {
          }}
          prompt={props.element.prompt}
          scale={props.formRating || props.userContext.scale}
          value={
            {
              rating: 5
            }
          }
        />
      );
    case 'rating-multi':
      return (
        <RatingMultiResponse
          onValueChange={(key, valueObject) => {
          }}
          ratingPrompt={props.element.ratingPrompt}
          notObservedPrompt={props.element.notObservedPrompt}
          notResponsivePrompt={props.element.notResponsivePrompt}
          minRating={props.element.minRating}
          defaultComments={props.element.defaultComments}
          requiredComments={props.element.requiredComments}
          hasTimeSpendField={props.element.hasTimeSpendField}
          requiredTimeSpendRatings={props.element.requiredTimeSpendRatings}
          timeSpendFieldPrompt={props.element.timeSpendFieldPrompt}
          overrideDefaultScores={props.element.overrideDefaultScores}
          scoreOverrides={props.element.scoreOverrides}
          scale={props.formRating || props.userContext.scale || 7}
          useNoNr={props.element.useNoNr}
          useNotObserved={props.element.useNotObserved}
          useNotResponsive={props.element.useNotResponsive}
          value={
            {
              rating: 5,
              notObserved: false,
              notResponsive: false
            }
          }
        />
      );
    case 'pto-rating-multi':
      return (
        <PtoRatingMultiResponse
          onValueChange={(key, valueObject) => {
          }}
          ratingPrompt={props.element.ratingPrompt}
          notObservedPrompt={props.element.notObservedPrompt}
          notResponsivePrompt={props.element.notResponsivePrompt}
          minRating={props.element.minRating}
          defaultComments={props.element.defaultComments}
          requiredComments={props.element.requiredComments}
          hasTimeSpendField={props.element.hasTimeSpendField}
          requiredTimeSpendRatings={props.element.requiredTimeSpendRatings}
          timeSpendFieldPrompt={props.element.timeSpendFieldPrompt}
          scale={props.formRating || props.userContext.scale || 7}
          useNoNr={props.element.useNoNr}
          useNotObserved={props.element.useNotObserved}
          useNotResponsive={props.element.useNotResponsive}
          value={
            {
              // rating: 5,
              // notObserved: false,
              // notResponsive: false,
              observationComment: ""
            }
          }
        />
      );
    case 'evaluation-rating':
      return (
        <EvaluationRatingResponse
          onValueChange={(key, valueObject) => {
          }}
          ratingPrompt={props.element.ratingPrompt}
          notObservedPrompt={props.element.notObservedPrompt}
          notResponsivePrompt={props.element.notResponsivePrompt}
          defaultComments={props.element.defaultComments}
          requiredComments={props.element.requiredComments}
          scoreOverrides={props.element.scoreOverrides}
          scale={props.element.scale || 3}
          useNoNr={props.element.useNoNr}
          useNotObserved={props.element.useNotObserved}
          useNotResponsive={props.element.useNotResponsive}
          heading="Trainee Self-Assessment"
          value={{
            rating: 2,
            notObserved: false,
            notResponsive: false,
            comment: ''
          }}
        />
      );
    case 'rating-simple':
      return (
        <RatingSimple
          onValueChange={(key, valueObject) => {
          }}
          ratingPrompt={props.element.ratingPrompt}
          acceptablePrompt={props.element.acceptable}
          unAcceptablePrompt={props.element.unAcceptable}
          useNoNr={props.element.useNoNr}
          useNo={props.element.useNo}
          notObservedPrompt={props.element.notObservedPrompt}
          notResponsivePrompt={props.element.notResponsivePrompt}
          requireAckResponse={props.element.requireAckResponse}
          value={
            {
              rating: 1
            }
          }
          hasTimeSpendField={props.element.hasTimeSpendField}
          timeSpendFieldPrompt={props.element.timeSpendFieldPrompt}
        />
      );
    case 'remedial-training':
      return (
        <RemedialTrainingResponse
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          name={'test'}
          value={{
            list: [{
              name: 'Driving',
              hours_spend: '02:30',
              reason: 'Dangerous driving',
              recap: 'He is improving',
              successful: true,
              continue: true
            }]
          }}
        />
      );
    case 'call-tracking':
      return (
        <CallTrackingResponse
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          name={'test'}
          value={{
            list: [{
              call_type: 'Fight',
              time: '02:30',
              location: 'By the bar',
              arrest: true,
              overview: 'Two guys were fighting',
              rating: 'acceptable'
            }]
          }}
        />
      )
    case 'daily-patrol-log':
      return (
        <DailyPatrolLogResponse
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          name={'test'}
          value={{
            list: [{
              type: 'Type',
              location: 'Location',
              activity: 'Activity',
              action: 'Action'
            }]
          }}
        />
      )
    case 'log-field':
      return (
        <LogFieldResponse
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          name='log-field-response'
          value={{
            list: [{}]
          }}
        />
      )
    case 'question-field':
      return (
        <QuestionFieldResponse
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          name='question-field-response'
          value={{
            list: [{}]
          }}
        />
      )
    case 'time-field':
      return (
        <TimeTrackingField
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          isEdit={true}
          name='time-response'
          value={{
            total: 300,
            segments: [{
              category: "Call practice",
              time: 100
            }]
          }}
        />
      )
    case 'pble':
      return (
        <PbleField
          onValueChange={(key, valueObject) => {
          }}
          element={props.element}
          isEdit={true}
          name='pble-field'
          value={{
            total: 300,
            segments: [{
              category: "Call practice",
              time: 100
            }]
          }}
        />
      )
    default:
      throw new Error('Invalid element schema');
  }
};

const QuestionCard = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function onAction(key) {
    switch (key) {
      case 'delete':
        return props.onDelete();
      case 'edit':
        return props.onEdit();
      case 'moveDown':
        return props.onMoveDown();
      case 'moveUp':
        return props.onMoveUp();
      default:
        throw new Error('Invalid action key');
    }
  }

  function showIcon(schema) {
    switch (schema) {
      case 'checkoff':
        return (
          <i className="fa fa-check"/>
        );
      case 'rating':
        return (
          <i className="fa fa-star"/>
        );
      case 'comment':
        return (
          <i className="fa fa-comment"/>
        );
      case 'datetime':
        return (
          <i className="fa fa-calendar"/>
        );

    }
  }


  // ----------------------
  // Render
  // ----------------------

  return (

    <Card className="mb-3">
      <CardHeader className="card-header--with-actions">

        <span>
          {showIcon(props.element.schema)}

          {`${props.schemaType.charAt(0).toUpperCase() + props.schemaType.slice(1)}`} Question
        </span>
        {props.canEdit &&
        <ElementCardActions
          actions={props.actions}
          onAction={key => onAction(key)}
          showActions
        />
        }
      </CardHeader>
      <CardBody>
        <ListGroup className="list-group-flush">
          <ListGroupItem>
            <DynamicFieldPreview {
                                   ...props
                                 }/>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};


const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext
  }
}

export default connect(mapStateToProps)(QuestionCard);
